<template>
  <div class="mt-component-form mb-4">
    <div class="header-flex">
      <h5 class=""><i class="dot"></i>{{ title }}</h5>
      <div class="header-buttons">
        <!-- Desktop: 항목추가 + 선택삭제 -->
        <vs-button v-if="!isPrint" class="desktop-only" color="secondary" @click="handleAddRow">항목추가</vs-button>
        <!-- PC/Mobile 공통: 선택삭제 -->
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          type="border"
          :disabled="selectedItemsCount === 0"
          @click="handleRemoveRowConfirm"
        >선택삭제</vs-button>
      </div>
    </div>

    <!-- 빈 목록 안내 메시지 -->
    <div v-if="tableList.length === 0 && !isPrint" class="empty-list-message">
      <div class="empty-content">
        <i class="feather icon-inbox empty-icon"></i>
        <p class="empty-text">항목을 추가해주세요</p>
        <vs-button
          color="primary"
          type="filled"
          @click="handleAddRow"
          class="empty-add-btn"
        >
          <i class="feather icon-plus mr-2"></i>
          첫 번째 항목 추가
        </vs-button>
      </div>
    </div>

    <!-- Desktop 테이블 레이아웃 -->
    <div class="desktop-layout" v-if="!isPrint">
      <div class="w-full mt-4" v-if="tableList.length > 0 || isPrint">
        <!--    head-->
        <div
          class="grid row-header border-left"
          style="font-weight: 700"
          :style="!isPrint ? 'grid-template-columns: 66px repeat(6, 1fr)' : 'grid-template-columns: repeat(6, 1fr)'"
        >
          <div v-if="!isPrint" class="row-header__item border-right">
            <vs-checkbox v-model="tableAllCheck" @change="changeAllCheck"></vs-checkbox>
          </div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">부서</div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">대상기계·기구명</div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">보유수량</div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">설치장소</div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">최근 검사일자</div>
          <div class="row-header__item border-right" style="background-color: #f9f9f9">비고</div>
        </div>

        <!-- rows -->
        <draggable class="w-full" :list="tableList" handle=".handle">
          <div
            class="w-full grid row-content border-left"
            :style="
              !isPrint
                ? 'grid-template-columns: 66px repeat(6, 1fr)'
                : 'grid-template-columns:      repeat(6, 1fr)'
            "
            v-for="(rows, indexRows) in tableList"
            :key="indexRows"
          >
            <div v-if="!isPrint" class="none-border-center border-right border-bottom h-full">
              <feather-icon class="handle mr-4 ml-2" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
              <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
            </div>

            <div class="item-area p-1 border-right border-bottom h-full">
              <ml-input v-if="!isPrint" rows="1" v-model="rows.부서" class="w-full flex-1 p-1" placeholder="입력" />
              <span v-else class="print-input">{{ rows.부서 }}</span>
            </div>
            <div class="item-area p-1 border-right border-bottom h-full">
              <ml-input v-if="!isPrint" rows="1" v-model="rows.기구명" class="w-full flex-1 p-1" placeholder="입력" />
              <span v-else class="print-input">{{ rows.기구명 }}</span>
            </div>
            <div class="item-area p-1 border-right border-bottom h-full">
              <ml-input v-if="!isPrint" rows="1" v-model="rows.보유수량" class="w-full flex-1 p-1" placeholder="입력" />
              <span v-else class="print-input">{{ rows.보유수량 }}</span>
            </div>
            <div class="item-area p-1 border-right border-bottom h-full">
              <ml-input v-if="!isPrint" rows="1" v-model="rows.설치장소" class="w-full flex-1 p-1" placeholder="입력" />
              <span v-else class="print-input">{{ rows.설치장소 }}</span>
            </div>
            <div class="item-area p-1 border-right border-bottom h-full">
              <date-selector v-if="!isPrint" v-model="rows.최근검사일자" class="w-full flex-1 p-1" />
              <span v-else class="print-input">{{ rows.최근검사일자 }}</span>
            </div>
            <div class="item-area p-1 border-right border-bottom h-full">
              <ml-input v-if="!isPrint" rows="1" v-model="rows.비고" class="w-full flex-1 p-1" placeholder="입력" />
              <span v-else class="print-input">{{ rows.비고 }}</span>
            </div>
          </div>
        </draggable>
      </div>
    </div>

    <!-- 인쇄 전용 HTML Table 레이아웃 -->
    <div class="print-table-layout" v-if="isPrint && tableList.length > 0">
      <table class="print-table">
        <thead>
          <tr>
            <th>부서</th>
            <th>대상기계·기구명</th>
            <th>보유수량</th>
            <th>설치장소</th>
            <th>최근 검사일자</th>
            <th>비고</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rows, indexRows) in tableList" :key="indexRows">
            <td>{{ rows.부서 }}</td>
            <td>{{ rows.기구명 }}</td>
            <td>{{ rows.보유수량 }}</td>
            <td>{{ rows.설치장소 }}</td>
            <td>{{ rows.최근검사일자 }}</td>
            <td>{{ rows.비고 }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile 카드 레이아웃 -->
    <div class="mobile-layout">
      <!-- 모바일 전체 선택 헤더 (아이템이 있을 때만) -->
      <div
        class="mobile-header"
        v-if="!isPrint && tableList.length > 0"
        @click="toggleAllCheck"
      >
        <vs-checkbox :value="tableAllCheck" />
        <span class="mobile-header-text">전체 선택</span>
      </div>

      <!-- 모바일 카드형 아이템들 -->
      <div class="mobile-cards-container">
        <div
          v-for="(rows, indexRows) in tableList"
          :key="indexRows"
          class="mobile-card"
          :class="{ 'selected': rows.is_checked, 'print-mode': isPrint }"
        >
          <!-- 카드 헤더 (체크박스 + 인덱스 + 삭제 버튼) -->
          <div class="mobile-card-header" v-if="!isPrint">
            <div class="mobile-card-header-left">
              <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
              <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
            </div>
            <vs-button
              class="mobile-delete-btn"
              color="danger"
              type="flat"
              size="small"
              @click="handleDeleteSingleItem(indexRows)"
            >
              삭제
            </vs-button>
          </div>
          <div class="mobile-card-header print-header" v-else>
            <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
          </div>

          <!-- 카드 내용 -->
          <div class="mobile-card-content">
            <!-- 부서 -->
            <div class="mobile-field">
              <label class="mobile-field-label">부서</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  rows="1"
                  v-model="rows.부서"
                  class="w-full"
                  placeholder="부서명을 입력하세요"
                />
                <span v-else class="mobile-print-value">{{ rows.부서 }}</span>
              </div>
            </div>

            <!-- 대상기계·기구명 -->
            <div class="mobile-field">
              <label class="mobile-field-label">대상기계·기구명</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  rows="1"
                  v-model="rows.기구명"
                  class="w-full"
                  placeholder="기계·기구명을 입력하세요"
                />
                <span v-else class="mobile-print-value">{{ rows.기구명 }}</span>
              </div>
            </div>

            <!-- 보유수량과 설치장소 - 한 줄로 배치 -->
            <div class="mobile-field-row">
              <div class="mobile-field mobile-field-half">
                <label class="mobile-field-label">보유수량</label>
                <div class="mobile-field-input">
                  <ml-input
                    v-if="!isPrint"
                    rows="1"
                    v-model="rows.보유수량"
                    class="w-full"
                    placeholder="수량"
                  />
                  <span v-else class="mobile-print-value">{{ rows.보유수량 }}</span>
                </div>
              </div>
              <div class="mobile-field mobile-field-half">
                <label class="mobile-field-label">설치장소</label>
                <div class="mobile-field-input">
                  <ml-input
                    v-if="!isPrint"
                    rows="1"
                    v-model="rows.설치장소"
                    class="w-full"
                    placeholder="설치장소"
                  />
                  <span v-else class="mobile-print-value">{{ rows.설치장소 }}</span>
                </div>
              </div>
            </div>

            <!-- 최근 검사일자 -->
            <div class="mobile-field">
              <label class="mobile-field-label">최근 검사일자</label>
              <div class="mobile-field-input">
                <date-selector v-if="!isPrint" v-model="rows.최근검사일자" class="w-full" />
                <span v-else class="mobile-print-value">{{ rows.최근검사일자 }}</span>
              </div>
            </div>

            <!-- 비고 -->
            <div class="mobile-field">
              <label class="mobile-field-label">비고</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  rows="1"
                  v-model="rows.비고"
                  class="w-full"
                  placeholder="비고사항을 입력하세요"
                />
                <span v-else class="mobile-print-value">{{ rows.비고 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 항목 추가 버튼 (아이템이 있을 때만) -->
      <div class="mobile-add-button-container" v-if="!isPrint && tableList.length > 0">
        <vs-button
          class="mobile-add-btn"
          color="primary"
          type="filled"
          size="large"
          @click="handleAddRow"
        >
          <i class="feather icon-plus mr-2"></i>
          항목 추가
        </vs-button>
      </div>
    </div>

    <!-- 삭제 확인 팝업 -->
    <vs-popup class="popup-example" title="삭제 확인" :active.sync="showDeleteConfirm">
      <div class="popup-content">
        <p class="delete-message">{{ deleteMessage }}</p>
        <div class="popup-buttons">
          <vs-button
            color="danger"
            type="filled"
            @click="confirmDelete"
          >
            삭제
          </vs-button>
          <vs-button
            color="dark"
            type="flat"
            @click="cancelDelete"
          >
            취소
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "TableModule1020",
  components: {
    DateSelector,
    draggable,
  },
  props: {
    title: String,
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  data() {
    return {
      tableAllCheck: false,
      tableList: [],
      showDeleteConfirm: false,
      deleteMessage: '',
      deleteAction: null,
      deleteIndex: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList(value) {
      this.$emit("input", value);
    },
  },
  computed: {
    selectedItemsCount() {
      return this.tableList.filter(item => item.is_checked).length;
    },
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.tableList.push({
        is_checked: this.tableAllCheck,
        부서: "",
        기구명: "",
        보유수량: "",
        설치장소: "",
        최근검사일자: "",
        비고: "",
      });
      this.updateList();
    },
    // 선택삭제 확인
    handleRemoveRowConfirm() {
      const selectedCount = this.tableList.filter(item => item.is_checked).length;
      if (selectedCount === 0) {
        this.$vs.notify({
          title: '알림',
          text: '삭제할 항목을 선택해주세요.',
          color: 'warning'
        });
        return;
      }

      this.deleteMessage = `선택된 ${selectedCount}개의 항목을 삭제하시겠습니까?`;
      this.deleteAction = 'batch';
      this.showDeleteConfirm = true;
    },
    // 개별 항목 삭제 확인
    handleDeleteSingleItem(index) {
      this.deleteMessage = `${index + 1}번째 항목을 삭제하시겠습니까?`;
      this.deleteAction = 'single';
      this.deleteIndex = index;
      this.showDeleteConfirm = true;
    },
    // 삭제 확인
    confirmDelete() {
      if (this.deleteAction === 'batch') {
        this.handleRemoveRow();
      } else if (this.deleteAction === 'single') {
        this.handleRemoveSingleRow();
      }
      this.showDeleteConfirm = false;
    },
    // 삭제 취소
    cancelDelete() {
      this.showDeleteConfirm = false;
      this.deleteAction = null;
      this.deleteIndex = null;
      this.deleteMessage = '';
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.splice(i, 1);
          i--;
        }
      }

      this.tableAllCheck = false;
      this.updateList();

      this.$vs.notify({
        title: '삭제 완료',
        text: '선택된 항목이 삭제되었습니다.',
        color: 'success'
      });
    },
    // 개별 항목 삭제 실행
    handleRemoveSingleRow() {
      this.tableList.splice(this.deleteIndex, 1);
      this.updateList();

      this.$vs.notify({
        title: '삭제 완료',
        text: '항목이 삭제되었습니다.',
        color: 'success'
      });
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.tableList) {
        data.is_checked = this.tableAllCheck;
      }
    },
    // 전체 선택 토글 (모바일 헤더 클릭 시)
    toggleAllCheck() {
      this.tableAllCheck = !this.tableAllCheck;
      this.changeAllCheck();
    },
    // update
    updateList() {
      this.$emit("updateList", this.tableList);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
$mobile-breakpoint: 768px;
$mobile-card-bg: #ffffff;
$mobile-card-border: 1px solid #e8e8e8;
$mobile-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
$mobile-selected-bg: #f0f9ff;
$mobile-selected-border: 1px solid #3b82f6;

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.desktop-only {
  display: inline-flex;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* 반응형 레이아웃 제어 */
.desktop-layout {
  display: block;
}
.mobile-layout {
  display: none;
}

/* 빈 목록 안내 메시지 */
.empty-list-message {
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  margin-bottom: 20px;
}

.empty-content {
  max-width: 300px;
  margin: 0 auto;
}

.empty-icon {
  font-size: 48px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 24px;
  font-weight: 500;
}

.empty-add-btn {
  min-height: 44px;
  padding: 12px 24px;
  font-weight: 600;

  .feather {
    font-size: 16px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }

  /* 모바일에서 항목추가 버튼 숨김 */
  .desktop-only {
    display: none !important;
  }

  /* 모바일 헤더 최적화 */
  .header-flex {
    .header-buttons {
      .vs-button {
        min-height: 40px;
        font-size: 14px;
        padding: 8px 16px;
      }
    }
  }

  /* 빈 목록 메시지 모바일 최적화 */
  .empty-list-message {
    padding: 40px 16px;
    margin-bottom: 16px;
  }

  .empty-icon {
    font-size: 40px;
  }

  .empty-text {
    font-size: 15px;
  }
}

/* Table */
.row-header {
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Mobile Styles */
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: $bg;
  border: $border;
  border-radius: 8px;
  margin-bottom: 15px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #f1f5f9;
    border-color: #94a3b8;
  }

  &:active {
    transform: scale(0.98);
  }

  .mobile-header-text {
    font-weight: 500;
    font-size: 16px;
    color: #374151;
    flex: 1;
  }

  .vs-checkbox {
    transform: scale(1.2); // 터치하기 쉽게 확대
    pointer-events: none; // 체크박스 직접 클릭 방지
  }
}

.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  background: $mobile-card-bg;
  border: $mobile-card-border;
  border-radius: 12px;
  box-shadow: $mobile-card-shadow;
  overflow: hidden;
  transition: all 0.3s ease;

  &.selected {
    background: $mobile-selected-bg;
    border: $mobile-selected-border;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  &.print-mode {
    box-shadow: none;
    border: $border;
    margin-bottom: 10px;
  }
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;

  &.print-header {
    background: $bg;
    justify-content: center;
  }

  .mobile-card-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .card-index {
    font-weight: 600;
    font-size: 16px;
    color: #1e293b;
  }

  .vs-checkbox {
    transform: scale(1.2);
  }

  .mobile-delete-btn {
    min-height: 32px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 6px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(220, 38, 38, 0.3);
    }
  }
}

.mobile-card-content {
  padding: 20px;
}

.mobile-field {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-row {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-half {
  flex: 1;
  margin-bottom: 0;
}

.mobile-field-label {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  line-height: 1.4;
}

.mobile-field-input {
  .vs-select,
  .vs-input,
  .vs-textarea {
    min-height: 44px; // 터치 친화적 크기

    .vs-select__input,
    .vs-input__input,
    .vs-textarea__input {
      font-size: 16px; // iOS 줌 방지
      padding: 12px 16px;
    }
  }

  .vs-select {
    .vs-select__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }

  .vs-textarea {
    .vs-textarea__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;
      min-height: 80px;
      resize: vertical;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }
}

.mobile-print-value {
  display: block;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  min-height: 20px;

  &.mobile-print-textarea {
    min-height: 60px;
    white-space: pre-wrap;
    line-height: 1.5;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .desktop-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }

  /* 테이블 인쇄 최적화 */
  .desktop-table-header,
  .desktop-table-row {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

/* 인쇄 전용 HTML Table 스타일 */
.print-table-layout {
  margin-top: 16px;
}

.print-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      background: #f9f9f9;
      border: 1px solid #cdcdcd;
      padding: 15px 8px;
      vertical-align: middle;
    }
  }

  tbody {
    tr {
      page-break-inside: avoid;
      break-inside: avoid;

      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 12px 8px;
        border: 1px solid #cdcdcd;
        vertical-align: middle;
        word-wrap: break-word;
        text-align: center;
      }
    }
  }
}

/* 인쇄 시 추가 최적화 */
@media print {
  .print-container {
    page-break-inside: auto;
  }

  .print-table {
    thead {
      display: table-header-group;
    }

    tbody {
      tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
    }
  }

  /* 제목과 테이블이 분리되지 않도록 */
  .header-flex {
    page-break-after: avoid;
    break-after: avoid;
  }

  .print-table-layout {
    page-break-before: auto;
    break-before: auto;
  }
}

/* 모바일 하단 항목 추가 버튼 */
.mobile-add-button-container {
  margin-top: 20px;
  padding: 0 5px;
}

.mobile-add-btn {
  width: 100%;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .feather {
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
  }
}

/* 삭제 확인 팝업 스타일 */
.popup-content {
  padding: 20px;
  text-align: center;
}

.delete-message {
  font-size: 16px;
  color: #374151;
  margin-bottom: 25px;
  line-height: 1.5;
}

.popup-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;

  .vs-button {
    min-width: 100px;
    min-height: 40px;
    font-weight: 600;
  }
}

/* 작은 모바일 화면 최적화 */
@media (max-width: 480px) {
  .mobile-card-content {
    padding: 15px;
  }

  .mobile-field-row {
    flex-direction: column;
    gap: 0;

    .mobile-field-half {
      margin-bottom: 15px;
    }
  }

  .mobile-header {
    padding: 12px;
  }

  .mobile-card-header {
    padding: 12px 15px;

    .mobile-card-header-left {
      .card-index {
        font-size: 14px;
      }
    }

    .mobile-delete-btn {
      min-height: 28px;
      padding: 6px 10px;
      font-size: 11px;
    }
  }

  .mobile-add-btn {
    min-height: 48px;
    font-size: 15px;

    .feather {
      font-size: 16px;
    }
  }

  .popup-buttons {
    flex-direction: column;
    gap: 10px;

    .vs-button {
      width: 100%;
    }
  }
}
</style>
